import { useEffect, useState } from "react";
import "./ArticlesSkeleton.css";

export default function ArticlesSkeleton({
  desktopArticleCount = 6,
  mobileArticleCount = 4,
}) {
  const [isDesktop, setIsDesktop] = useState(
    window.innerWidth >= 992
  );

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth >= 992);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const articleCount = isDesktop
    ? desktopArticleCount
    : mobileArticleCount;

  const articles = Array.from(
    { length: articleCount },
    (_, index) => index
  );

  return (
    <section className="home-articles home-articles-skeleton">
      <div className="container">

        {/* Header */}
        <div className="home-articles-header">

          <div className="home-articles-header__title">
            <span className="articles-skeleton-title" />
          </div>

          <div className="home-articles-header__center">
            <span className="articles-skeleton-line" />
          </div>

          <div className="home-articles-header__more">
            <span className="articles-skeleton-more" />
            <span className="articles-skeleton-arrow" />
          </div>

        </div>

        {isDesktop ? (
          <div className="home-articles-desktop">

            <div className="home-articles-row">
              {articles
                .slice(0, Math.ceil(articleCount / 2))
                .map((index) => (
                  <ArticleSkeletonCard key={index} />
                ))}
            </div>

            <div className="home-articles-row">
              {articles
                .slice(Math.ceil(articleCount / 2))
                .map((index) => (
                  <ArticleSkeletonCard key={index} />
                ))}
            </div>

          </div>
        ) : (
          <div className="articles-skeleton-mobile">
            {articles.map((index) => (
              <div
                className="articles-skeleton-mobile__slide"
                key={index}
              >
                <ArticleSkeletonCard />
              </div>
            ))}
          </div>
        )}

      </div>
    </section>
  );
}


function ArticleSkeletonCard() {
  return (
    <article className="article-card-skeleton">

      <div className="article-card-skeleton__image" />

      <div className="article-card-skeleton__content">

        <div className="article-card-skeleton__category" />

        <div className="article-card-skeleton__title">
          <span />
          <span />
        </div>

        <div className="article-card-skeleton__description">
          <span />
          <span />
        </div>

        <div className="article-card-skeleton__bottom">
          <span />
          <span />
        </div>

      </div>

    </article>
  );
}